export const login = {
  signInHeader: "Sign In",
  signInButtonText: "Sign In",
  passwordResetButtonText: "Click here to reset password",
  backToLoginPage: "Back to login",
  stringNewUserText:
    "New user? <router-link to='/claim'> Click here </router-link> to confirm your account."
};
